module.exports = __webpack_public_path__ + "img/yuanchafang.85e0d934.png";